import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@/styles/unitlinked-popup.css'

export function openUnitLinkedPopup() {
  return Swal.fire({
    title: 'แจ้งเตือน',
    html: `
      <p class="ul-text">
        ท่านต้องการต่ออายุการขึ้นทะเบียนตัวแทนประกันชีวิตควบการลงทุน (Unit Linked) ด้วยหรือไม่?
      </p>
      <p class="ul-warning">
        กรณีเลือกไม่ต้องการ ท่านจะไม่สามารถนำเสนอขายประกันชีวิตควบการลงทุนได้
        และบริษัทจะทำการโอนผลงานกรมธรรม์ประกันชีวิตควบการลงทุน (ถ้ามี)
        ให้กับตัวแทนท่านอื่นตามระเบียบบริษัท
      </p>
    `,
    icon: undefined,               // ไม่ใช้ไอคอน เพื่อให้เหมือนภาพ
    width: 640,                    // ความกว้างใกล้เคียงภาพ
    backdrop: true,
    showCancelButton: true,
    reverseButtons: true,          // สลับตำแหน่งให้ “ต้องการ” อยู่ขวา
    cancelButtonText: 'ไม่ต้องการ',
    confirmButtonText: 'ต้องการ',
    buttonsStyling: false,         // ใช้คลาส custom เอง
    focusConfirm: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      popup: 'ul-swal',            // กล่องหลัก (ขอบฟ้า มุมโค้ง)
      title: 'ul-title',
      htmlContainer: 'ul-html',
      cancelButton: 'ul-btn-ghost btn',// l-btn
      confirmButton: 'ul-btn btn-bla'// ul-btn-primary
    }
  })
}
